import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { useState } from 'react';
// import { BackgroundHandler } from 'shared/ui/BackgroundHandler/BackgroundHandler';
import { FormTypes, Forms } from 'entities/Forms/Forms';
import AvatarGirl from 'shared/assets/img/avatar/Girl.png';
import AvatarBoy from 'shared/assets/img/avatar/Boy.png';
import { classNames } from 'shared/lib/classNames/classNames';
import { useBackgrounds } from 'shared/lib/hooks/useBackgrounds/useBackgrounds';
import { LazyBackground } from 'shared/ui/LazyBackground';
import cls from './CharacterSelectPage.module.scss';

// import background1700 from 'shared/assets/img/avatar/room-1700.png';
// import background1200 from 'shared/assets/img/avatar/room-1200.png';
// import background1024 from 'shared/assets/img/avatar/room-1024.png';
// import background768 from 'shared/assets/img/avatar/room-768.png';
// import background370 from 'shared/assets/img/avatar/room-370.png';

export const CharacterSelectPage = () => {
    const [sex, setSex] = useState('m');
    const handlerIsActive = (value: 'm' | 'w') => setSex(value);
    const room = useBackgrounds('room');

    // const images = {
    //     1700: `url(${background1700})`,
    //     1200: `url(${background1200})`,
    //     1024: `url(${background1024})`,
    //     768: `url(${background768})`,
    //     370: `url(${background370})`,
    // };

    return (
        <LazyBackground
            tnImg={room.tnBackground}
            originalImg={room.background}
            overlay="linear-gradient(136deg, rgba(15, 167, 223, 0.50) 0%, rgba(61, 187, 110, 0.50) 57.29%, rgba(142, 245, 11, 0.50) 97.92%)"
        >
            <div className={cls.page}>
                {/* <BackgroundHandler images={images}/> */}
                <Wrapper className={cls.wrapper}>
                    <div className={cls.avatarContainer}>
                        <ul className={cls.avatarList}>
                            <li className={classNames(cls.avatarItem, { [cls.active]: sex !== 'w' })}>
                                <img src={AvatarGirl} alt="" />
                            </li>
                            <li className={classNames(cls.avatarItem, { [cls.active]: sex !== 'm' })}>
                                <img src={AvatarBoy} alt="" />
                            </li>
                        </ul>
                    </div>
                    <div className={cls.form}>
                        <Forms type={FormTypes.avatar} stateHandler={handlerIsActive} />
                    </div>
                </Wrapper>
            </div>
        </LazyBackground>
    );
};
